const Bloco = ({ className }: { className: string }) => (
  <div className={`animate-pulse rounded-md bg-muted-foreground/15 ${className}`} />
);

export const EsqueletoStatus = () => {
  return (
    <div aria-hidden="true" className="flex flex-col gap-3.5">
      <section className="cartao-status px-6 py-7">
        <div className="flex items-start gap-3.5">
          <Bloco className="mt-2 size-3.5 flex-none rounded-full" />
          <div className="min-w-0 flex-1">
            <Bloco className="h-8 w-2/3" />
            <Bloco className="mt-3 h-4 w-full" />
            <Bloco className="mt-2 h-4 w-4/5" />
          </div>
        </div>
        <div className="mt-[22px] flex flex-wrap gap-[26px] border-t border-border pt-[18px]">
          {['resumo-1', 'resumo-2', 'resumo-3'].map((chave) => (
            <div key={chave}>
              <Bloco className="h-3 w-24" />
              <Bloco className="mt-2 h-4 w-16" />
            </div>
          ))}
        </div>
      </section>

      <section className="cartao-status">
        <Bloco className="h-4 w-24" />
        {['servico-1', 'servico-2', 'servico-3', 'servico-4', 'servico-5'].map((chave) => (
          <div key={chave} className="mt-4 border-t border-border pt-4">
            <Bloco className="h-4 w-1/3" />
            <Bloco className="mt-3 h-[26px] w-full" />
          </div>
        ))}
      </section>
    </div>
  );
};
